<template>
  <nav aria-labelledby="mainmenulabel">
    <h2 id="mainmenulabel" class="sr-only">Main Menu</h2>
    <ul class="main-menu">
      <li v-for="(menu, index) in sidebarMenus" :key="index" :class="getClass(menu.path)">
        <router-link :to="menu.path">
          <font-awesome-icon :aria-label="menu.name" :icon="['fas', menu.icon]" />
          <span>{{ $t(`sidebar.${menu.name}`) }}</span>
        </router-link>
      </li>
      <li class="logout">
        <a @click="logout">
          <font-awesome-icon :aria-label="$t('header.logOut')" :icon="['fa', 'sign-out-alt']" />
          <span>{{ $t('header.logOut') }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Sidebar',
  computed: {
    ...mapState({
      currentBusinessUserRole: state => state.user.currentBusinessUserRole,
    }),
    ...mapGetters({
      currentBusinessProducts: 'business/currentBusinessProducts',
    }),
    sidebarMenus() {
      const sidebarMenus = [];
      this.$router.options.routes.forEach(route => {
        if (route.meta && route.meta.menuName && route.meta.authorize) {
          const hasAuthorization = route.meta.authorize.includes(this.currentBusinessUserRole);
          const hasProduct =
            (route.meta.product && this.currentBusinessProducts.includes(route.meta.product)) || !route.meta.product;
          if (hasAuthorization && hasProduct) {
            sidebarMenus.push({
              name: route.meta.menuName,
              path: route.path,
              icon: route.meta.icon,
            });
          }
        }
      });
      return sidebarMenus;
    },
  },
  methods: {
    getClass(menuPath) {
      return this.$route.path === menuPath ? ' active' : '';
    },
    async logout() {
      await this.$store.dispatch('user/logout', {
        auth: this.$auth,
        redirect: window.location.origin,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
ul.main-menu {
  padding: 0 30px 30px 0;
  list-style-type: none;
  margin: 0;
  li {
    margin: 7px 0;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    a {
      display: block;
      padding: 14px 15px 14px 45px;
      color: $dark-grey;
      transition: all 200ms;
      &:hover {
        text-decoration: none;
      }
      &:hover,
      &:focus,
      &:active {
        color: $blue;
      }
      svg {
        width: 20px;
        text-align: center;
      }
      span {
        margin-left: 12px;
        display: inline-block;
      }
    }
    &.active {
      background-color: $lighter-blue;
      font-weight: bold;
      a {
        color: $blue;
      }
    }
    @media (min-height: 700px) {
      &.logout {
        position: absolute;
        bottom: 100px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    padding: 0 15px 15px 0;
    li {
      margin: 10px 0;
      a {
        padding: 10px 0 10px 37px;
        svg {
          width: 25px;
        }
        span {
          display: none;
        }
      }
      @media (min-height: 640px) {
        &.logout {
          position: absolute;
          bottom: 100px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    padding: 0;
    margin: 40px 50px 0 0;
    li {
      a {
        padding: 15px 0 15px 30px;
      }
    }
    @media (min-height: 570px) {
      li.logout {
        position: absolute;
        bottom: 40px;
      }
    }
  }
}
</style>
